module.exports = __webpack_public_path__ + "static/media/whstaApp-conversations.fc601ba5.png";